import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProfileAvatarInfoDto } from '../shared/dto/profile-avatar-info.dto';

import { ProfileService } from '../shared/profile.service';

@Component({
  selector: 'wl-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  styleUrls: ['./profile-avatar.component.less'],
  standalone: false
})
export class ProfileAvatarComponent implements OnInit, OnChanges {
  @Input() profileId: number;

  /**
   * Valid options: sm, xl
   */
  @Input() size = 'sm';
  @Input() style: object;
  @Input() isOrg = false;

  profileAvatarInfo: ProfileAvatarInfoDto;
  imgClassObject: object;
  iconColor = 'default';
  isLoading = false;

  private _subs = new Subscription();
  constructor(private _profileService: ProfileService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.profileId && this.profileId) {
      this._profileService.getProfileAvatarInfo(this.profileId).then((info) => {
        this.profileAvatarInfo = info;
        this.setupStyles();
      });
    }
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }

  private setupStyles() {
    this.imgClassObject = {
      individual: !this.profileAvatarInfo.IsOrg,
      organization: this.profileAvatarInfo.IsOrg,
    };

    this.iconColor = this.profileAvatarInfo.IsMember ? this.profileAvatarInfo.MemberTypeIconColor.toLowerCase() : 'default';
  }
}
